import { Button } from '@/components/custom/button'

const ButtonClose = ({ onClose, title }) => {
  return (
    <Button
      type="button"
      variant="outlet"
      onClick={() => onClose()}
      className="border border-[#EEF1F5] bg-[#FAFAFA] text-[#333] shadow-sm"
    >
      {title || 'Đóng'}
    </Button>
  )
}

export default ButtonClose
